import { isDefined } from '@sgme/fp';
import type { ColTypeDef } from 'ag-grid-community';
import type { CustomCellRendererProps } from 'ag-grid-react';
import type { Frequency, ScheduleRunStatus } from 'apiConnector/scheduledRun/model';
import type {
  IScheduledQuotesBlotterItem,
  ScheduledRangeOrDays,
} from 'apiConnector/scheduledRun/scheduledQuotesBlotter';
import { DaysTriggerDisplay } from 'components/shared/ScheduledRun/shared/DaysTriggerDisplay';
import { FrequencyDisplay } from 'components/shared/ScheduledRun/shared/FrequencyDisplay';
import { RangeTriggerDisplay } from 'components/shared/ScheduledRun/shared/RangeTriggerDisplay';
import { ScheduleStatusBadge } from 'components/shared/ScheduledRun/shared/ScheduleStatusBadge';

export const runStatus: ColTypeDef<IScheduledQuotesBlotterItem, ScheduleRunStatus> = {
  cellRenderer: ({ value }: CustomCellRendererProps<IScheduledQuotesBlotterItem, ScheduleRunStatus>) =>
    isDefined(value) ? (
      <div className="d-flex align-items-center h-100 justify-content-start">
        <ScheduleStatusBadge status={value} />
      </div>
    ) : (
      <></>
    ),
  filter: 'agTextColumnFilter',
  filterParams: { filterOptions: ['contains'] },
};
export const scheduledRangeOrDays: ColTypeDef<IScheduledQuotesBlotterItem, ScheduledRangeOrDays> = {
  cellRenderer: ({ value, data }: CustomCellRendererProps<IScheduledQuotesBlotterItem, ScheduledRangeOrDays>) => {
    if (!isDefined(value)) {
      return;
    }
    return data?.type === 'range' && value.startDate && value.endDate ? (
      <RangeTriggerDisplay startDate={value.startDate} endDate={value.endDate} />
    ) : (
      <DaysTriggerDisplay days={value.triggerDays} />
    );
  },
  equals(valueA, valueB) {
    return (
      (valueA?.endDate === valueB?.endDate &&
        valueA?.startDate === valueB?.startDate &&
        valueA?.triggerDays.length === valueB?.triggerDays.length &&
        valueA?.triggerDays.every((d, i) => valueB?.triggerDays[i] === d)) ??
      false
    );
  },
  filter: 'agTextColumnFilter',
  filterParams: { filterOptions: ['contains'] },
};
export const runFrequency: ColTypeDef<IScheduledQuotesBlotterItem, Frequency> = {
  cellRenderer: ({ value }: CustomCellRendererProps<IScheduledQuotesBlotterItem, Frequency>) => (
    <FrequencyDisplay {...value} />
  ),
  filter: 'agTextColumnFilter',
  filterParams: { filterOptions: ['contains'] },
  equals(valueA, valueB) {
    return valueA?.type === valueB?.type && valueA?.value === valueB?.value;
  },
};
